import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Grid } from 'semantic-ui-react';
import Auth from '@aws-amplify/auth';
import PageNav from '../../../components/PageNav';
import { namespaces } from '../../../constants/translation';
import TimelineLog from './TimelineLog';
import config from '../../../../config';

const DEFAULT_PAGINATION = {
  current_page: 1,
  per_page: 20,
  total_count: 0,
  total_pages: 1,
  has_next: false,
  has_prev: false,
};

export async function fetchActivityLogs(opportunityId, { page = 1, perPage = 20 } = {}) {
  const url = new URL(`${config.get('logApiURL')}/api/v1/activity-logs`);
  const params = { entity_type: 'opportunity', entity_id: opportunityId, per_page: perPage, page };
  url.search = new URLSearchParams(params).toString();

  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
    mode: 'cors',
  });

  if (!res.ok) {
    const message = await res.text();
    Bugsnag.notify(`Failed to GET ${url}: ${message}`);
    throw new Error(message || 'Failed to fetch activity logs');
  }
  return res.json();
}

class ActivityLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: [],
      loading: false,
      current_page: 1,
      pagination: DEFAULT_PAGINATION,
    };
  }

  componentDidMount() {
    this.mounted = true;
    const { id } = this.props;

    if (id) {
      this.loadLogs(id);
    }
  }

  componentDidUpdate(prevProps) {
    const { id, tabID } = this.props;
    const idJustLoaded = !prevProps.id && id;
    const userSwitchedToThisTab = prevProps.tabID !== tabID && tabID === 6;

    if ((idJustLoaded || userSwitchedToThisTab) && id) {
      this.loadLogs(id);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  loadLogs = (opportunityId, pageNumber = 1) => {
    this.setState({ loading: true, current_page: pageNumber });

    fetchActivityLogs(opportunityId, { page: pageNumber, perPage: 20 })
      .then((res) => {
        if (this.mounted) {
          this.setState({
            logs: res.activity_logs || [],
            pagination: res.pagination || DEFAULT_PAGINATION,
            loading: false,
          });
        }
      })
      .catch((err) => {
        console.error('Error fetching logs:', err);
        if (this.mounted) {
          this.setState({
            loading: false,
            logs: [],
            pagination: DEFAULT_PAGINATION,
          });
        }
      });
  }

  handlePageChange = (targetPageNumber) => {
    const { id } = this.props;
    const { loading } = this.state;

    if (loading) return;

    this.loadLogs(id, targetPageNumber);
  }

  render() {
    const { logs, pagination = DEFAULT_PAGINATION, loading, current_page } = this.state;

    const logsToRender = Array.isArray(logs) && logs.length > 0 ? logs : [];

    const limit = pagination == null ? 20 : pagination.per_page;
    const offset = ((current_page || 1) - 1) * limit;
    const dataSize = logsToRender.length;
    const count = pagination == null ? 0 : pagination.total_count;

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <TimelineLog activityLog={logsToRender} isFullWidth />
            <PageNav
              loading={loading}
              currentPage={current_page}
              count={count}
              limit={limit}
              offset={offset}
              dataSize={dataSize}
              isCursorPagination={false}
              onChange={this.handlePageChange}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(ActivityLog);



// WEBPACK FOOTER //
// ./src/containers/Opportunities/Overview/ActivityLog.jsx